// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"528":"a46fa766","707":"b35a2645","950":"08812e1b"}[chunkId] + ".chunk.js";
};